module.exports = __webpack_public_path__ + "img/business3_E.35257316.png";